import { useProject } from '../project-hooks/useProject';
import { getI18nTexts, getProjectLanguageForUser } from './project-i18n-model';

export const useI18nTexts = (textKeys, project) => {
    const usedProject = useProject();
    const languageKey = getProjectLanguageForUser(project || usedProject);

    return getI18nTexts({ languageKey, textKeys });
};
